import { ColumnDef } from '@tanstack/react-table'
import { ILegalPerson, ILegalPersonPayment, IRenderInputs } from '../models/models'
import Status from '../components/UI/Status'
import dateFormat from 'dateformat'

export const legalPersonsColumns: ColumnDef<ILegalPerson>[] = [
	{
		accessorKey: 'status',
		header: 'Статус',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
	{
		accessorKey: 'name',
		header: 'Назва',
		minSize: 300,
	},
	{
		accessorKey: 'directorPhone',
		header: 'Номер телефону',
		enableSorting: false,
	},
	{
		accessorKey: 'directorEmail',
		header: 'E-mail',
		enableSorting: false,
		minSize: 200,
	},
	{
		accessorKey: 'registeredAt',
		header: 'Дата реєстрації',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'balance',
		header: 'Баланс',
		cell: (value) => Number(value.getValue<any>()) / 100,
	},
	{
		accessorKey: 'code',
		header: 'ЄДРПОУ',
		enableSorting: false,
	},
	{
		accessorKey: 'directorFio',
		header: 'Керівник',
	},
	{
		accessorKey: 'address',
		header: 'Адреса',
		enableSorting: false,
		minSize: 300,
	},
	{
		accessorKey: 'region',
		header: 'Регіон',
		cell: (value) => value.row.original.region.name,
	},
]

export const legalPersonPaymentsColumns: ColumnDef<ILegalPersonPayment>[] = [
	{
		accessorKey: 'id',
		header: 'id платежу',
	},
	{
		accessorKey: 'datetime',
		header: 'Дата',
		cell: (value) => dateFormat(value.row.original.datetime, 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'datetime2',
		header: 'Час',
		cell: (value) => dateFormat(value.row.original.datetime, 'HH:MM'),
		enableSorting: false,
	},
	{
		accessorKey: 'price',
		header: 'Сума',
		cell: (value) => Number(value.getValue<any>()) / 100,
	},
	{
		accessorKey: 'balance',
		header: 'Баланс',
		cell: (value) => Number(value.getValue<any>()) / 100,
	},
	{
		accessorKey: 'comment',
		header: 'Коментар',
	},
]

export interface legalPersonsInputs {
	name: string
	code?: string
	address: string
	iban?: string
	bank?: string
	directorName: string
	directorLastname: string
	directorSurname?: string | null
	directorBirthdate?: any
	directorEmail: string
	directorPhone: string
	status?: boolean | null
	overdraftAmount?: number | null
	lowerLimit?: number | null
	discountPerLiter?: number | null
}

export const legalPersonsInputsData: IRenderInputs<legalPersonsInputs>[] = [
	{
		name: 'name',
		type: 'text',
		placeholder: 'Назва',
	},
	{
		name: 'code',
		type: 'text',
		placeholder: 'ЄДРПОУ',
	},
	{
		name: 'address',
		type: 'text',
		placeholder: 'Адреса',
	},
	{
		name: 'directorEmail',
		type: 'text',
		placeholder: 'E-mail',
	},
	{
		name: 'directorLastname',
		type: 'text',
		placeholder: 'Прізвище директора',
	},
	{
		name: 'directorPhone',
		type: 'text',
		placeholder: 'Номер телефону',
	},
	{
		name: 'directorName',
		type: 'text',
		placeholder: "Ім'я директора",
	},
	{
		name: 'directorBirthdate',
		type: 'date',
		placeholder: 'Дата народження',
	},
	{
		name: 'directorSurname',
		type: 'text',
		placeholder: 'По батькові директора',
	},
	{
		name: 'bank',
		type: 'text',
		placeholder: 'Банк',
	},
	{
		name: 'iban',
		type: 'text',
		placeholder: 'IBAN',
	},
	{
		name: 'overdraftAmount',
		type: 'number',
		step: 0.01,
		placeholder: 'Сума овердрафту',
	},
	{
		name: 'lowerLimit',
		type: 'number',
		step: 0.01,
		placeholder: 'Граничне значення на балансі',
	},
	{
		name: 'discountPerLiter',
		type: 'number',
		step: 0.01,
		placeholder: 'Знижка грн/л',
	},
]
